<div
  class="login-register"
    style="background-image: url(assets/images/background/download.jpg)">
  <div class="login-register-box">
    <mat-card>
      <mat-card-content>
        <button mat-flat-button class="microsoft-signup btn-block btn-lg m-t-20 m-b-20" (click)="onMsClick()" [disabled]="loading" >
          <img src="assets/images/microsoft.svg" alt="Microsoft logo" width="20px" class="button-image">
          <span>{{ (isRegister ? "Sign up with Microsoft" : "Login with Microsoft") }}</span>
        </button>
        <div *ngIf="loading">
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <div class="separator">
          <div class="line"></div>
          <h6>or</h6>
          <div class="line"></div>
        </div>
        <form [formGroup]="formGroupControls" (ngSubmit)="onSubmit()">
          <fieldset fxLayout="row wrap" [disabled]="loading">
            <mat-form-field fxFlex="100">
              <input matInput placeholder="Email address" type="email" [formControl]="controls.email" fxFlex="100" autocomplete="username"/>
              <mat-error *ngIf="controls.email.hasError('required') && controls.email.touched">You must include an email address.</mat-error>
              <mat-error *ngIf="controls.email.hasError('pattern') && controls.email.touched">Invalid email address.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="100">
              <input matInput type="password" placeholder="Password" [formControl]="controls.password" fxFlex="100" autocomplete="current-password"/>
              <mat-error *ngIf="controls.password.hasError('required') && controls.password.touched">You must include password.</mat-error>
              <mat-error *ngIf="controls.password.hasError('pattern')">Must contain 1 number and be 8 characters.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="100" *ngIf="isRegister">
              <input matInput placeholder="Confirm Password" [formControl]="controls.confirmPassword" type="password" fxFlex="100"/>
              <mat-error *ngIf="controls.confirmPassword.hasError('required') && controls.confirmPassword.touched">You must confirm your password.</mat-error>
              <mat-error *ngIf="controls.confirmPassword.hasError('notSame') && controls.confirmPassword.touched">Passwords do not match.</mat-error>
            </mat-form-field>

            <div *ngIf="stateError" fxFlex fxLayout="column" fxLayoutAlign="end center" style="margin-top: 12px">
              <mat-error>{{ message }}</mat-error>
            </div>

            <button
              mat-raised-button
              color="primary"
              class="btn-block btn-lg m-t-20 m-b-20"
              type="submit"
              [disabled]="!formGroupControls?.valid || loading">
              {{ (isRegister ? "Create your account" : "Login") }}
            </button>

            <div class="text-center" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <span>{{ (isRegister ?  "Already have an account?" : "Need to sign up?") }}
                <a (click)="toggleIsRegister()" class="link text-info">{{ (isRegister ? "Login" : "Sign up") }}</a>
              </span>
            </div>
          </fieldset>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
